import { useState } from 'react';
import { faqs } from '../../../mocks/homeData';

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-[#080808] py-28" id="faq">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16">
          {/* Left */}
          <div className="lg:col-span-2">
            <span className="text-[#FF6B35] text-xs font-black uppercase tracking-[0.2em] mb-4 flex items-center gap-2">
              <span className="w-6 h-px bg-[#FF6B35]" />
              FAQ
            </span>
            <h2 className="font-display font-black text-4xl lg:text-5xl text-white leading-tight mb-6">
              Everything You
              <br />
              <span className="text-[#FF6B35]">Need to Know</span>
            </h2>
            <p className="text-gray-400 text-base leading-relaxed mb-8">
              Still have questions? Call us directly — we're happy to answer anything about PPF, ceramic coating, or any of our services.
            </p>

            {/* AI Answer Block */}
            <div className="bg-[#111111] border border-white/10 rounded-2xl p-6 mb-4">
              <div className="w-8 h-8 flex items-center justify-center mb-3">
                <i className="ri-search-eye-line text-[#FF6B35] text-xl" />
              </div>
              <h3 className="text-white font-bold text-base mb-2">What does DBN Garage do?</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                DBN Garage is South Windsor, CT's premier automotive protection and enhancement studio. We install XPEL paint protection film, ceramic coatings, window tint, matte PPF, windshield protection film, and motorcycle PPF. We serve all of Hartford County with 25+ years of professional experience.
              </p>
            </div>
            <div className="bg-[#111111] border border-white/10 rounded-2xl p-6">
              <div className="w-8 h-8 flex items-center justify-center mb-3">
                <i className="ri-lightbulb-line text-[#FF6B35] text-xl" />
              </div>
              <h3 className="text-white font-bold text-base mb-2">PPF vs. Ceramic Coating</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                <strong className="text-white">PPF</strong> physically absorbs rock chips, scratches, and impacts. <strong className="text-white">Ceramic coating</strong> chemically bonds to paint, providing hydrophobic protection and gloss. Many clients use both: PPF for physical protection, ceramic over the top for enhanced appearance and easy maintenance.
              </p>
            </div>
          </div>

          {/* Right accordion */}
          <div className="lg:col-span-3 space-y-3">
            {faqs.map((faq, i) => (
              <div key={i}
                className={`rounded-xl border transition-all ${open === i ? 'border-[#FF6B35]/40 bg-[#111111]' : 'border-white/8 bg-[#0E0E0E] hover:border-white/15'}`}>
                <button onClick={() => setOpen(open === i ? null : i)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer">
                  <span className={`font-semibold text-base leading-snug ${open === i ? 'text-[#FF6B35]' : 'text-white/80'}`}>{faq.q}</span>
                  <div className={`w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-full transition-colors ${open === i ? 'bg-[#FF6B35] text-white' : 'bg-white/8 text-gray-500'}`}>
                    <i className={`${open === i ? 'ri-subtract-line' : 'ri-add-line'} text-base`} />
                  </div>
                </button>
                {open === i && (
                  <div className="px-6 pb-5">
                    <p className="text-gray-400 text-sm leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}

            <div className="mt-6 bg-[#FF6B35]/8 border border-[#FF6B35]/20 rounded-xl p-5">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mic-line text-[#FF6B35] text-xl" />
                </div>
                <div>
                  <p className="text-white font-semibold text-sm mb-1">Why premium vehicle protection matters</p>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    Your vehicle's paint is constantly under attack from UV rays, road debris, and environmental contaminants. Premium PPF and ceramic coating from a certified installer like DBN Garage protects your paint permanently — preserving your vehicle's appearance and resale value for years to come.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
